export const phoneSectionBoxSx = {
  p: 2,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  backgroundColor: (theme) => theme.palette.common.white,
  marginTop: 3,
};

export const phoneSectionDividerSx = {
  mb: 2,
};

export const phoneActionsStackSx = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  width: "100%",
  mt: 2,
  justifyContent: "space-evenly",
  alignItems: "center",
  alignContent: "center",
  rowGap: 1.5,
};

export const showPhoneNumberStackSx = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  width: "100%",
  gap: 2,
  minWidth: 0,
};

export const showPhoneNumberIconSx = {
  color: "text.primary",
  flexShrink: 0,
  fontSize: "1.5rem",
  width: "1.5rem",
  height: "1.5rem",
  display: "block",
};

export const showPhoneNumberFieldSx = {
  flex: 1,
  minWidth: 0,
  "& .MuiOutlinedInput-root": {
    backgroundColor: (theme) => theme.palette.action.hover,
  },
  "& .MuiOutlinedInput-input": {
    fontWeight: 700,
    typography: "body1",
    opacity: 0.72,
    cursor: "default",
  },
};

export const showPhoneNumberChipSx = {
  minWidth: 120,
  flexShrink: 0,
  fontWeight: 700,
};

export const showPhoneNumberChipStatusIconSx = {
  color: "inherit !important",
};
